import { Tooltip } from "flowbite-react";
import Slider from "react-slick";
import { toImagePath } from "../utils/globalFunctions";
import Container from "./Container";
import MainCard from "./MainCard";
import PageContainer from "./PageContainer";

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  autoplay: true,

  slidesToShow: 1,
  slidesToScroll: 1,
};

const DetailSectionMultiImage = ({
  bgImg = "/images/hero-image.jpeg",
  pageTitle = "",
  headerTitle = "",
  images = [],
  title = "",
  content = "",
  isHeaderTitleBottom = false,
}) => {
  return (
    <PageContainer bgImg={bgImg} title={pageTitle}>
      <Container isAlignTop>
        <MainCard>
          <div
            className={`flex ${
              isHeaderTitleBottom ? "flex-col-reverse" : "flex-col"
            } `}
          >
            {headerTitle && (
              <div className="header-content">
                <h2 className="header-content__title">
                  {headerTitle ?? "หัวข้อ"}
                </h2>
              </div>
            )}
            <div>
              <Slider {...settings}>
                {images?.map((img) => {
                  return (
                    <div className="w-full">
                      <Tooltip content={img?.description}>
                        <img
                          className="img-aspect-video"
                          src={toImagePath(img?.path)}
                          alt={img?.title}
                        />
                      </Tooltip>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>

          <div
            className="dangerous-html-content"
            dangerouslySetInnerHTML={{
              __html: title ?? <></>,
            }}
          />
          <div
            className="dangerous-html-content"
            dangerouslySetInnerHTML={{
              __html: content ?? <></>,
            }}
          />
        </MainCard>
      </Container>
    </PageContainer>
  );
};

export default DetailSectionMultiImage;
